(function() {
    'use strict';

    var blockStepper = {
        templateUrl: 'app/components/block-stepper/block-stepper.html',
        controller: blockStepperController,
        bindings: {
            name: '@',
            icon: '@',
            description: '@',
            checkboxModel: '=',
            readonly: '<',
            checkboxClick: '&',
            checkboxLabel: '@',
            hideCheckbox: '<',
            hideIcon: '<'
        },
        controllerAs: 'vm',
        transclude: true
    };

    angular
        .module('showcaseApp')
        .component('blockStepper', blockStepper);

    /** @ngInject */
    function blockStepperController() {
        var vm = this;
        vm.readonly = vm.readonly || false;
        vm.$onInit = function() {
            vm.hideIcon = vm.hideIcon === undefined ? true : vm.hideIcon;
        };
    }
})();
